import { render, staticRenderFns } from "./moneyBack.vue?vue&type=template&id=3743ab96&scoped=true"
import script from "./moneyBack.vue?vue&type=script&lang=js"
export * from "./moneyBack.vue?vue&type=script&lang=js"
import style0 from "./moneyBack.vue?vue&type=style&index=0&id=3743ab96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743ab96",
  null
  
)

export default component.exports